import { ADDRESS_FIELDS } from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/common/steps/AddressStep/constants';
import { VALIDATION_FIELDS } from '@interlayer/js/app/hooks/useValidationRules/constants';

export const VALIDATION_FIELDS_CONTACT_INFORMATION = [
    ...ADDRESS_FIELDS,
    VALIDATION_FIELDS.searchAddress,
    VALIDATION_FIELDS.email,
    VALIDATION_FIELDS.phone
];
